import { SetStateAction, useEffect, useMemo, useState } from 'react'

import { EyeIcon } from '@heroicons/react/24/outline'
import debounce from 'debounce'
import { Select } from 'flowbite-react'
import { useParams } from 'react-router-dom'

import PedidosModalDetail from './detalhe-item-pedido.modal'
import Loader from '@/components/Loader'
import TableItem from '@/components/Table'
import PaginationItem from '@/components/Table/pagination-item'
import SearchTableItem from '@/components/Table/search'
import { useDetalhePedidoContext } from '@/contexts/detalhe-pedido.context'
import { useGetListarVendas } from '@/hooks/queries/use-get-listar-vendas'
import { TABLE_HEADERS_DETALHES_PEDIDOS_OPERADORA } from '@/pages/Pedidos/constants'

const DetailItensPedido = () => {
  const { id } = useParams()
  const [isPedidoItensListModalOpen, setIsPedidoItensListModalOpen] =
    useState<boolean>(false)
  const [agrupado, setAgrupado] = useState<boolean>(false)
  const { setOperadoraId } = useDetalhePedidoContext()
  const handleOpenRepassesModal = (
    idOperadora: string,
    vendaAgrupada: boolean
  ) => {
    setAgrupado(vendaAgrupada)
    setOperadoraId(idOperadora)
    setIsPedidoItensListModalOpen(true)
  }
  const [itemsPage, setItemsPage] = useState<number>(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [search, setSearch] = useState('')

  const {
    data: pedidoOperadorasList,
    isLoading: isLoadingPedidoOperadoras,
    isIdle
  } = useGetListarVendas({
    params: {
      pedidoId: id ?? '',
      inicio: (itemsPage - 1) * itemsPerPage,
      comprimento: itemsPerPage,
      procurar: search,
      situacoesItem: [
        'Ativo',
        'Devolvido',
        'AguardandoDevolver',
        'Finalizado',
        'CnabGerado'
      ]
    }
  })

  const mapedProperties = useMemo(() => {
    return pedidoOperadorasList?.conteudo?.resultados?.map(item => {
      return {
        nomeDaOperadora: item.nomeDaOperadora,
        qtdColaboradores: item.quantidadeDeCpfs,
        idOperadora: item.idOperadora,
        valorTotal: item.totalVenda.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        }),
        acoes: (
          <EyeIcon
            className='h-5 w-5 text-primary-dark justify-center items-center cursor-pointer'
            data-testid='eye-icon'
            onClick={() =>
              handleOpenRepassesModal(item.idOperadora, item.agrupado)
            }
          />
        )
      }
    })
  }, [pedidoOperadorasList])

  const handleSearch = debounce((e: SetStateAction<string>) => {
    setSearch(e)
  }, 500)

  useEffect(() => {
    itemsPage > 1 && setItemsPage(1)
  }, [itemsPerPage])

  const itensTotalPages = Math.ceil(
    (pedidoOperadorasList?.conteudo?.quantidadeDeItems ?? 0) / itemsPerPage
  )

  return (
    <>
      <div className='overflow-x-auto'>
        <SearchTableItem
          isAddItem={false}
          isSearchInputEnabled={true}
          setFilterText={e => handleSearch(e)}
        />
        {isLoadingPedidoOperadoras ? (
          <div className='h-96 w-full flex justify-center items-center'>
            <Loader size={'xl'} />
          </div>
        ) : (
          <TableItem
            isActions={false}
            isRowClicable={false}
            data={mapedProperties || []}
            headers={TABLE_HEADERS_DETALHES_PEDIDOS_OPERADORA}
            deleteAction={() => void 0}
            hasCustomActions={false}
            idKey='pedidoId'
            isIdle={isIdle}
            data-testid='table-pedidos-operadoras'
          />
        )}
        <PaginationItem
          totalItems={pedidoOperadorasList?.conteudo?.quantidadeDeItems ?? 0}
          totalPages={itensTotalPages}
          pageSize={itemsPerPage}
          onPageChange={(pageParam: number) => setItemsPage(pageParam)}
          forceDisplay={true}
        >
          <Select
            id='select-page-size'
            data-testid='select-page-size'
            onChange={e => setItemsPerPage(Number(e.target.value))}
            defaultValue={itemsPerPage}
          >
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='50'>50</option>
            <option value='100'>100</option>
          </Select>
        </PaginationItem>
      </div>
      {isPedidoItensListModalOpen ? (
        <PedidosModalDetail
          agrupado={agrupado}
          isOpen={isPedidoItensListModalOpen}
          onClose={() => setIsPedidoItensListModalOpen(false)}
        />
      ) : null}
    </>
  )
}

export default DetailItensPedido